/* src/app/admin/exchange-rate/exchange-rate.component.scss */
/*# sourceMappingURL=exchange-rate.component-WCUUVM36.css.map */
